import { render, staticRenderFns } from "./MotivoTramiteProcesso.vue?vue&type=template&id=7d9d3d8a&scoped=true"
import script from "./MotivoTramiteProcesso.vue?vue&type=script&lang=js"
export * from "./MotivoTramiteProcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9d3d8a",
  null
  
)

export default component.exports